import request from '../request';

function query() {
  return request({
    url: `/bookList/findAll`,
    method: 'get'
  });
}

function show(q) {
  return request({
    url: `/bookList/show`,
    params:q,
    method: 'get'
  });
}

function editShow(id) {
  return request({
    url: `/bookList/show/${id}`,
    method: 'get'
  });
}

function add(params) {
  return request({
    url: '/bookList/add',
    method: 'post',
    data: params
  });
}

function update(id,params) {
  return request({
    url: `/bookList/update/${id}`,
    method: 'post',
    data: params
  });
}

function showApply(id,pid,q) {
  return request({
    url: `/bookList/showApply/${id}/${pid}`,
    params:q,
    method: 'get'
  });
}

function findChapter(id) {
  return request({
    url: `/bookList/findChapter/${id}`,
    method: 'get',
  });
}

function importAll(params) {
  return request({
    url: '/bookList/importAll',
    method: 'post',
    data: params
  });
}

function deleteAll(params) {
  return request({
    url: `/bookList/deleteAll`,
    method: 'delete',
    data: params
  });
}
export default {
  query,
  show,
  editShow,
  add,
  update,
  showApply,
  findChapter,
  importAll,
  deleteAll
};